module.exports = __webpack_public_path__ + "img/custom-empty-image.276c05f0.png";